import api from "./api";

export interface CompanyProfile {
  legalName: string;
  gstin: string;
  pan: string;
  stateCode: string;
}

export type RoundOffMode = "none" | "0.05" | "1.00";

export interface AppSettings {
  cardSecurityAmount: number;
  companyProfile?: CompanyProfile;
  allowNegativeStock?: boolean;
  defaultTaxInclusive?: boolean;
  roundOffMode?: RoundOffMode;
  maxDiscountPercent?: number;
  sessionTimeoutMinutes?: number;
}

export type SettingsUpdatePayload = {
  cardSecurityAmount?: number;
  companyProfile?: Partial<CompanyProfile>;
  allowNegativeStock?: boolean;
  defaultTaxInclusive?: boolean;
  roundOffMode?: RoundOffMode;
  maxDiscountPercent?: number;
  sessionTimeoutMinutes?: number;
};

export const settingsAPI = {
  getSettings: async (): Promise<AppSettings> => {
    const response = await api.get("/settings");
    return response.data.data;
  },

  updateSettings: async (payload: SettingsUpdatePayload): Promise<AppSettings> => {
    const response = await api.put("/settings", payload);
    return response.data.data;
  },
};
